<div class="landing-wrapper">
	<!-- Hero Section -->
	<div class="hero-section">
		<img [src]="src" alt="arrowXL van" />
		<div class="hero-text">{{ deliveryConstants.welcomeText }} </div>
	</div>
	<div class="delivery-wrapper">
		<div class="delivery-container">
			<div class="delivery-info" *ngIf="flowType === 'tracking'">
				<h3>{{ deliveryConstants.title }}</h3>
				<p>
					{{ deliveryConstants.description }}
					{{ deliveryConstants.helpText }}
					<a [href]="deliveryConstants.helpLinkTarget">{{ deliveryConstants.helpLinkText }}</a>
				</p>
			</div>
			<div class="delivery-info" *ngIf="flowType === 'booking'">
				<h3>{{ deliveryConstants.titleBooking }}</h3>
				<p>
					{{ deliveryConstants.descriptionBooking }}
					{{ deliveryConstants.helpTextBooking }}
				</p>
			</div>

			<form
				class="delivery-form"
				#trackingForm="ngForm"
				novalidate
				autocomplete="off"
				(ngSubmit)="trackingForm.form.valid && onFormSubmit()"
			>
				<mat-form-field appearance="outline">
					<input
						matInput
						type="text"
						#trackingNumber="ngModel"
						name="trackingNumber"
						[placeholder]="deliveryConstants.trackingNumber"
						[(ngModel)]="trackingFormPayload.trackingNumber"
						name="trackingNumber"
						autocomplete="off"
						[maxlength]="16"
						[minlength]="10"
						required
					/>
					<mat-error *ngIf="trackingNumber.errors?.['required']">{{ deliveryConstants.trackingNumberRequired }}</mat-error>
					<mat-error
						*ngIf="!trackingNumber.errors?.['required'] && trackingNumber.invalid && (trackingNumber.dirty || trackingNumber.touched)"
					>
						{{ deliveryConstants.trackingNumberInvalid }}
					</mat-error>
				</mat-form-field>

				<mat-form-field appearance="outline">
					<input
						matInput
						type="text"
						#deliveryPostcode="ngModel"
						#deliveryPostcodeInput
						name="deliveryPostcode"
						[placeholder]="deliveryConstants.deliveryPostcode"
						[(ngModel)]="trackingFormPayload.deliveryPostcode"
						name="deliveryPostcode"
						autocomplete="off"
						[minlength]="5"
						[maxlength]="8"
						required
					/>
					<mat-error *ngIf="deliveryPostcode.errors?.['required']">{{ deliveryConstants.deliveryPostcodeRequired }}</mat-error>
					<mat-error
						*ngIf="!deliveryPostcode.errors?.['required'] && deliveryPostcode.invalid && (deliveryPostcode.dirty || deliveryPostcode.touched)"
					>
						{{ deliveryConstants.deliveryPostcodeInvalid }}
					</mat-error>
				</mat-form-field>

				<button mat-button color="primary" class="submit-btn">{{ deliveryConstants.btnSubmit }}</button>
			</form>
		</div>
		<p class="error">{{ errorMessage }}</p>
	</div>
</div>

<section class="about-section">
	<div class="about-container">
		<!-- Left side: image -->
		<div class="about-image">
			<img [src]="abtSrc" alt="Delivery illustration" width="400" height="400" />
		</div>

		<!-- Right side: text -->
		<div class="about-text">
			<p>{{ deliveryConstants.aboutText }}</p>
			<a class="about-link">
				{{ deliveryConstants.aboutLinkText }}
			</a>
		</div>
	</div>
</section>
<app-faq-section id="faq-section"></app-faq-section>
